module.exports = __webpack_public_path__ + "static/video-37f98461781336941f61a22fce3476d4.mp4";